import React from 'react';
import styled from "styled-components";
import {useShoppingCartStore} from "../../model/store";
import Button from "../../../../shared/ui/button/Button";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

const StyledButton = styled(Button)`
    padding: 5px;
    width: max-content;
    //margin-left: auto;

    svg {
        width: clamp(14px, 4vw, 24px);
        height: clamp(14px, 4vw, 24px);
    }
`

interface IProps {
    id: number;
}

const CartRemoveGoods: React.FC<IProps> = ({id}) => {
    const removeItem = useShoppingCartStore(state => state.removeItem)
    const onRemoveItem = () => {
        removeItem(id)
    }
    return (
        <StyledButton className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-btn-remove')}
                      onClick={onRemoveItem}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M16.1388 21H7.8588C6.8118 21 5.9418 20.192 5.8638 19.147L4.9668 7H19.0008L18.1338 19.142C18.0588 20.189 17.1878 21 16.1388 21V21Z"
                      stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 11V17" stroke="white" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M4 7H20" stroke="white" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path
                    d="M17 7L15.987 4.298C15.694 3.517 14.948 3 14.114 3H9.886C9.052 3 8.306 3.517 8.013 4.298L7 7"
                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.4298 11L14.9998 17" stroke="white" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M8.57016 11L9.00016 17" stroke="white" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
            </svg>
        </StyledButton>
    );
};

export default CartRemoveGoods;